import React, { type FC } from 'react';
import { useTranslations } from '@vocab/react';
import { Box, Column, Columns, Text } from 'braid-design-system';
import translations from './.vocab';
import * as styles from './styles.css';

export const TableHeader: FC = () => {
  const { t } = useTranslations(translations);

  return (
    <Box background="surface" paddingY="small" paddingX="gutter">
      <Box className={styles.contentColumnSection}>
        <Columns space="small" collapseBelow="tablet">
          <Box className={styles.nameColumn}>
            <Column width="content">
              <Text size="small">{t('Name')}</Text>
            </Column>
          </Box>

          <Box className={styles.statusColumn}>
            <Column width="content">
              <Text size="small">{t('Status')}</Text>
            </Column>
          </Box>

          <Box className={styles.mostRecentRoleColumn}>
            <Column width="content">
              <Text size="small">{t('Most recent role')}</Text>
            </Column>
          </Box>

          <Box className={styles.mostRecentApplicationColumn}>
            <Column width="content">
              <Text size="small">{t('Most recent application')}</Text>
            </Column>
          </Box>
          <Box className={styles.previousAppsColumn}>
            <Column width="content">
              <Text size="small">{t('Previous applications')}</Text>
            </Column>
          </Box>
        </Columns>
      </Box>
    </Box>
  );
};
